import { Link } from "react-router-dom";
// Import images
import acting1 from "../../assets/images/all_courses/Acting/acting1.jpg";
import acting2 from "../../assets/images/all_courses/Acting/acting2.jpg";
import acting3 from "../../assets/images/all_courses/Acting/acting3.jpg";

import cinematography1 from "../../assets/images/all_courses/cinematography/cinematography1.jpg";
import cinematography2 from "../../assets/images/all_courses/cinematography/cinematography2.jpg";
import cinematography3 from "../../assets/images/all_courses/cinematography/cinematography3.jpg";

import direction1 from "../../assets/images/all_courses/Direction/direction1.jpg";
import direction2 from "../../assets/images/all_courses/Direction/direction2.jpg";
import direction3 from "../../assets/images/all_courses/Direction/direction3.jpg";

import editing1 from "../../assets/images/all_courses/Digital_Marketing/digitalmarketing1.jpg";
import editing2 from "../../assets/images/all_courses/Digital_Marketing/digitalmarketing2.jpg";
import editing3 from "../../assets/images/all_courses/Digital_Marketing/digitalmarketing3.jpg";

import production1 from "../../assets/images/all_courses/Dubbing_and_voiceover/dubbingandvoiceover1.jpg";
import production2 from "../../assets/images/all_courses/Dubbing_and_voiceover/dubbingandvoiceover2.jpg";
import production3 from "../../assets/images/all_courses/Dubbing_and_voiceover/dubbingandvoiceover3.jpg";

import screenwriting1 from "../../assets/images/all_courses/influencer_creator/influencercreator1.jpg";
import screenwriting2 from "../../assets/images/all_courses/influencer_creator/influencercreator2.jpg";
import screenwriting3 from "../../assets/images/all_courses/influencer_creator/influencercreator3.jpg";

import sound1 from "../../assets/images/all_courses/Personality_Development/personalitydevelopment1.jpg";
import sound2 from "../../assets/images/all_courses/Personality_Development/personalitydevelopment2.jpg";
import sound3 from "../../assets/images/all_courses/Personality_Development/personalitydevelopment3.jpg";

import vfx1 from "../../assets/images/all_courses/Photography/Photography1.jpg";
import vfx2 from "../../assets/images/all_courses/Photography/Photography2.jpg";
import vfx3 from "../../assets/images/all_courses/Photography/Photography3.jpg";

import lighting1 from "../../assets/images/all_courses/Script_Writting/scriptwritting1.jpg";
import lighting2 from "../../assets/images/all_courses/Script_Writting/scriptwritting2.jpg";
import lighting3 from "../../assets/images/all_courses/Script_Writting/scriptwritting3.jpg";

import makeup1 from "../../assets/images/all_courses/Sound_Engineering/soundengineering1.jpg";
import makeup2 from "../../assets/images/all_courses/Sound_Engineering/soundengineering2.jpg";
import makeup3 from "../../assets/images/all_courses/Sound_Engineering/soundengineering3.jpg";

import costume1 from "../../assets/images/all_courses/Video_editing/videoediting1.jpg";
import costume2 from "../../assets/images/all_courses/Video_editing/videoediting2.jpg";
import costume3 from "../../assets/images/all_courses/Video_editing/videoediting3.jpg";

import setdesign1 from "../../assets/images/all_courses/Visual_Effects/visualeffects1.jpg";
import setdesign2 from "../../assets/images/all_courses/Visual_Effects/visualeffects2.jpg";
import setdesign3 from "../../assets/images/all_courses/Visual_Effects/visualeffects3.jpg";

const CourseCard = ({ course, reverse }) => {

  // fallback image (agar kabhi null aaye)
  const image = course.backgroundImage1 || "https://via.placeholder.com/600x400";

  return (
    <div
      className={`flex flex-col mb-10 overflow-hidden bg-white shadow-lg rounded-2xl md:flex-row ${
        reverse ? "md:flex-row-reverse" : ""
      }`}
    >

      {/* ✅ IMAGE SECTION (FIXED) */}
      <div className="w-full md:w-1/2 bg-gray-50 overflow-hidden">
        <img
          src={image}
          alt={course.title}
          className="object-cover w-full h-96 transition duration-500 hover:scale-105"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/600x400";
          }}
        />
      </div>

      {/* ✅ CONTENT */}
      <div className="flex flex-col justify-center w-full p-8 md:w-1/2">
        <h3 className="mb-3 text-2xl font-bold text-orange-900">
          {course.title}
        </h3>

        <p className="mb-6 text-gray-600">
          {course.description}
        </p>

   <Link
  to={course.route || `/${course.slug}`}
  className="inline-flex items-center w-fit px-4 py-1.5 text-xs font-semibold text-white rounded-full bg-gradient-to-r from-[#8C3608] to-[#594B12] hover:opacity-90 transition-all duration-300"
>
  Read More →
</Link>
      </div>
    </div>
  );
};

const ServicesMain = () => {
  // Static dummy data for courses
  const services = [
    {
      title: "Acting",
      description:
        "Master the art of acting with expert training. Learn techniques, expressions, and character development to bring stories to life. Build confidence and versatility to excel in theater, film, and television. Explore improvisation, voice modulation, and emotional depth to captivate audiences and create memorable performances.",
      backgroundImage1: acting1,
      backgroundImage2: acting2,
      backgroundImage3: acting3,
      route: "acting",
    },
    {
      title: "Direction",
      description:
        "Learn to visualize and execute compelling stories as a director. Understand scene composition, actor coordination, and storytelling techniques. Develop leadership skills to guide your team and bring your creative vision to life. Gain insights into pre-production, shooting, and post-production processes for impactful filmmaking.",
      backgroundImage1: direction1,
      backgroundImage2: direction2,
      backgroundImage3: direction3,
      route: "direction",
    },
    {
      title: "Cinematography",
      description:
        "Explore the art of visual storytelling through cinematography. Master camera techniques, lighting setups, and framing to create stunning visuals. Learn to use equipment effectively and understand the role of cinematography in enhancing narratives. Develop a unique style to craft visually engaging films.",
      backgroundImage1: cinematography1,
      backgroundImage2: cinematography2,
      backgroundImage3: cinematography3,
      route: "cinemetography",
    },
    {
      title: "Digital Marketing",
      description:
        "Discover the power of digital marketing in the modern world. Learn strategies for social media, SEO, and content creation to promote brands effectively. Understand analytics and audience targeting to maximize reach. Build campaigns that drive engagement and achieve measurable results.",
      backgroundImage1: editing1,
      backgroundImage2: editing2,
      backgroundImage3: editing3,
      route: "digital-marketing",
    },
    {
      title: "Dubbing And Voiceover",
      description:
        "Enhance your voice acting skills with dubbing and voiceover training. Learn voice modulation, script interpretation, and recording techniques. Explore the art of syncing voice with visuals to create impactful performances. Develop versatility to work across animation, films, and advertisements.",
      backgroundImage1: production1,
      backgroundImage2: production2,
      backgroundImage3: production3,
      route: "dubbing-and-voiceover",
    },
    {
      title: "Influencer Creator",
      description:
        "Become a successful influencer by mastering content creation. Learn storytelling, audience engagement, and branding strategies. Understand social media platforms and analytics to grow your presence. Build a unique identity and create impactful content that resonates with your audience.",
      backgroundImage1: screenwriting1,
      backgroundImage2: screenwriting2,
      backgroundImage3: screenwriting3,
      route: "influencer-creator",
    },
    {
      title: "Personality Development",
      description:
        "Transform your personality with expert guidance. Build confidence, communication skills, and emotional intelligence. Learn to present yourself effectively in personal and professional settings. Develop a positive mindset and leadership qualities to achieve success in all aspects of life.",
      backgroundImage1: sound1,
      backgroundImage2: sound2,
      backgroundImage3: sound3,
      route: "personality-development",
    },
    {
      title: "Photography",
      description:
        "Capture stunning moments with professional photography skills. Learn camera settings, composition, and lighting techniques. Explore various photography styles, including portrait, landscape, and macro. Develop a creative eye to tell stories through your lens and create impactful visuals.",
      backgroundImage1: vfx1,
      backgroundImage2: vfx2,
      backgroundImage3: vfx3,
      route: "photography",
    },
    {
      title: "Script Writing",
      description:
        "Master the craft of scriptwriting to create engaging stories. Learn structure, character development, and dialogue writing. Understand the nuances of storytelling for films, television, and digital platforms. Develop your unique voice and bring your ideas to life through compelling scripts.",
      backgroundImage1: lighting1,
      backgroundImage2: lighting2,
      backgroundImage3: lighting3,
      route: "script-writing",
    },
    {
      title: "Sound Engineering",
      description:
        "Dive into the world of sound engineering to create immersive audio experiences. Learn recording, mixing, and mastering techniques. Understand the role of sound in storytelling and enhance your technical skills to work in music, film, and media production.",
      backgroundImage1: makeup1,
      backgroundImage2: makeup2,
      backgroundImage3: makeup3,
      route: "sound-engineering",
    },
    {
      title: "Video Editing",
      description:
        "Learn the art of video editing to craft compelling narratives. Master editing software, transitions, and effects to enhance storytelling. Understand pacing, color grading, and sound design to create professional-quality videos. Develop skills to work in film, television, and digital media.",
      backgroundImage1: costume1,
      backgroundImage2: costume2,
      backgroundImage3: costume3,
      route: "video-editing",
    },
    {
      title: "Visual Effects",
      description:
        "Bring imagination to life with visual effects training. Learn compositing, 3D modeling, and animation techniques. Understand the role of VFX in storytelling and enhance your technical skills to create stunning visuals for films, games, and advertisements.",
      backgroundImage1: setdesign1,
      backgroundImage2: setdesign2,
      backgroundImage3: setdesign3,
      route: "visual-effects",
    },
  ];

  return (
    <section className="min-h-screen py-16 bg-white">
      <div className="container px-4 mx-auto">
        <div className="mb-12 text-center">
          <h2 className="mb-3 text-4xl font-extrabold tracking-wide text-gray-900 drop-shadow-sm">
            Our Signature Courses
          </h2>
          <p className="max-w-xl mx-auto text-lg text-gray-600">
            Unlock your creative potential with our industry-leading film and
            media courses.
          </p>
        </div>
        {/* Render Course Cards */}
        {services.map((service, idx) => (
          <CourseCard course={service} key={idx} reverse={idx % 2 === 1} />
        ))}
      </div>
    </section>
  );
};

export default ServicesMain;
